import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-train",
  "use": "icon-leo-train-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-train\">\r\n<g transform=\"translate(-176.128 -90.112) scale(1.344000)\">\r\n<path d=\"M192 288h640v448H192V288zm96 96v256h448V384H288z\" />\r\n  <path d=\"M384 160h256v128H384V160zm64 448h128v64H448v-64z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-train.svg
// module id = sgPT
// module chunks = 534